// extracted by mini-css-extract-plugin
module.exports = {"top":"styles_top__tGWMg","form":"styles_form__3H2Xi"};